import React from 'react';
import styles from './TipoEnsinoSelector.module.css';

interface TipoEnsinoSelectorProps {
  label?: string;
  value: 'curricular' | 'extracurricular' | '';
  onChange: (value: 'curricular' | 'extracurricular') => void;
  disabled?: boolean;
  error?: string;
  required?: boolean;
  showDescription?: boolean;
}

const tipoOptions = [
  {
    value: 'curricular' as const,
    label: 'Curricular',
    description: 'Séries do ensino regular obrigatório'
  },
  {
    value: 'extracurricular' as const,
    label: 'Extracurricular',
    description: 'Atividades complementares e opcionais'
  }
];

export const TipoEnsinoSelector: React.FC<TipoEnsinoSelectorProps> = ({
  label = 'Tipo de Ensino',
  value,
  onChange,
  disabled = false,
  error,
  required = false,
  showDescription = true,
}) => {
  return (
    <div className={styles.selectorContainer}>
      <label className={styles.label}>
        {label}
        {required && <span style={{ color: 'var(--color-error-500)' }}> *</span>}
      </label>
      
      <div className={styles.optionsContainer}>
        {tipoOptions.map((option) => (
          <button
            key={option.value}
            type="button"
            className={`${styles.optionButton} ${value === option.value ? styles['optionButton--selected'] : ''} ${error ? styles['optionButton--error'] : ''}`}
            disabled={disabled}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>

      {showDescription && value && (
        <p className={styles.descriptionText}>
          {tipoOptions.find(option => option.value === value)?.description}
        </p>
      )}

      {error && <span className={styles.errorMessage}>{error}</span>}
    </div>
  );
};
